import React from "react";
import { Routes, Route } from 'react-router-dom';
import MainApp from "./components/MainApp";
import ChefPage from "./components/ChefPage";

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<MainApp />} />
            <Route path="/chef" element={<ChefPage />} />
        </Routes>
    );
}